<template>
  <div class='kd-ws-audio-player js-ws-audio-player'>
    <div class='kd-ws-audio-player__waveform js-ws-audio-player-waveform' ref='audioEl'></div>
    <div class='kd-ws-audio-player__controls'>
      <a class='kd-ws-audio-player__controls_btn' v-if="!playing" @click="play">
        <i class='kf kf-controls-play'></i>
      </a>
      <a class='kd-ws-audio-player__controls_btn' v-if="playing" @click="pause">
        <i class='kf kf-controls-pause'></i>
      </a>
      <div class='kd-ws-audio-player__controls_spacer'></div>
      <a class='kd-ws-audio-player__controls_btn' v-if="!muted" @click="mute">
        <i class='kf kf-volume-high'></i>
      </a>
      <a class='kd-ws-audio-player__controls_btn' v-if="muted" @click="unmute">
        <i class='kf kf-volume-none'></i>
      </a>
    </div>
  </div>
</template>

<script>
  // TODO : COMBINE THIS WITH JESALS AUDIO SLIDE COMPONENT
  export default {
    props: {
      media: Object
    },
    data() {
      return {
        wavesurfer: null,
        playing: false,
        muted: false
      }
    },
    methods: {
      init() {
        this.wavesurfer = WaveSurfer.create({
          container: this.$refs['audioEl'],
          waveColor: '#37575b',
          progressColor: '#2f3738'
        });
        this.wavesurfer.load(this.media.url);

        this.wavesurfer.on('ready', () => {
          this.$nextTick(() => {
            this.wavesurfer.drawer.container.style.display = '';
            this.wavesurfer.drawBuffer();
            this.$nextTick(() => {
              this.$emit('ready', this.media.id)
              console.log("ready")
            });
          })
        });

        this.wavesurfer.on('error', (e) => {
          this.$emit('ready', this.media.id)
        });
      },
      play() {
        this.wavesurfer.play();
        this.playing = true;
      },
      pause() {
        if (this.playing) {
          this.wavesurfer.pause();
          this.playing = false;
        }
      },
      mute() {
        this.wavesurfer.setVolume(0);
        this.muted = true;
      },
      unmute() {
        this.wavesurfer.setVolume(1);
        this.muted = false;
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.init();
      });
    },
    destroyed() {
      this.wavesurfer.destroy();
    }
  }
</script>
